import React, { FC, useCallback, useState } from "react";

import { AnimatedLayout } from "@/views/components/Layout";
import { ProfileType } from "@/views/components/ProfileTypePicker";

import { OnboardingPrivatePersonSteps } from "../../Onboarding/PrivatePerson";
import { OnboardingProfileType } from "../../Onboarding/types";
import { OnboardingSupplierSteps } from "./Supplier";

interface IOnboardingProfileTypeSelectProps {
  onRequestToJoinSent?: () => void;
}
const SUPPLIER_TYPE: ProfileType = "supplier";
const PRIVATE_PERSON_TYPE: ProfileType = "private-person";

export const OnboardingProfileTypeSelect: FC<IOnboardingProfileTypeSelectProps> = ({ onRequestToJoinSent }) => {
  const [profileType, setProfileType] = useState<OnboardingProfileType>(SUPPLIER_TYPE);

  const handleChangeToSupplier = useCallback(() => {
    setProfileType(SUPPLIER_TYPE);
  }, []);

  const handleChangeToPrivatePerson = useCallback(() => {
    setProfileType(PRIVATE_PERSON_TYPE);
  }, []);

  const handleRequestToJoinSent = () => {
    if (onRequestToJoinSent) {
      onRequestToJoinSent();
    }
  };

  return (
    <AnimatedLayout>
      {profileType === "private-person" && <OnboardingPrivatePersonSteps onCancel={handleChangeToSupplier} />}

      {profileType === "supplier" && (
        <OnboardingSupplierSteps
          onPrivatePersonChange={handleChangeToPrivatePerson}
          onRequestToJoinSent={handleRequestToJoinSent}
        />
      )}
    </AnimatedLayout>
  );
};
